import { AutogenLayoutHighwayControl } from "./autogen/AutogenLayoutHighwayControl";
import {
    ChangeEvent, DataDisplayEvent, DataSource,
    DataSourceMode,
    LayoutProps,
    LookupModelSelectionEvent, TableRow,
    TableRowBeforeSaveEvent, Textbox
} from "@mcleod/components";
import { Api, ModelRow, ModelRowType, StringUtil } from "@mcleod/core";
import { CommonDialogs } from "@mcleod/common";


interface ControlLayoutProps extends LayoutProps {
    vendorId: string;
}

export class HighwayControl extends AutogenLayoutHighwayControl {

    private _vendorId: string;


    constructor(props?: Partial<ControlLayoutProps>) {
        super(props);
        this._vendorId = props?.vendorId || "";
    }

    async onLoad() {
        this.mainDataSource.addAfterModeChangeListener((event) => {
            if (event.newMode === DataSourceMode.ADD && this.mainDataSource.activeRow) {
                this.activeRow.setValues(this.mainDataSource.activeRow.get("highway_default_values"));
            }
        });
    }

    async postDataSources(vendorId: string): Promise<boolean> {
        try {
            this.mainDataSource?.activeRow?.set("vendor_id", vendorId);
            await this.mainDataSource.post();
            return true;
        } catch {
            return false;
        }
    }

    async switchIsActiveOnChange(event: ChangeEvent) {
        if (!event.userInitiatedChange || event.newValue !== true) return;

        const response = await Api.search("lme/powerbroker/get-update-default-vendor", {
            vendor: this._vendorId,
            monitoring_vendor: true,
        });

        if (!response.data[0]?.default_vendor_list) return;

        const userConfirmed = await this.confirmChangeActiveVendor(response.data[0].default_vendor_list, response.data[0].vendor);
        if (userConfirmed) {
            await Api.update("lme/powerbroker/get-update-default-vendor", {
                vendor: this._vendorId,
                monitoring_vendor: true,
            });
        } else {
            this.switchIsActive.checked = false;
        }
    }

    private async confirmChangeActiveVendor(defaultVendorList: any, vendor: any): Promise<boolean> {
        return await CommonDialogs.showYesNo(
            `Only one service provider can be active at a time. Would you like to activate ${vendor} and deactivate the following service provider? ${this.getDefaultVendorList(defaultVendorList)}`,
            "Change Active Vendor"
        );
    }

    private getDefaultVendorList(defaultVendorList: any): string {
        return "\n\n" + defaultVendorList.map((vendor: any) => vendor.vendor).join("\n");
    }

    textboxContactVerificationPrefOnChange(event: ChangeEvent) {
        if (event.userInitiatedChange) {
            if (StringUtil.isEmptyString(event.newValue)) {
                this.textboxContactUnverifyAction.required = false;
                this.textboxContactUnknownAction.required = false;
                this.textboxContactNoResponseAction.required = false;
                this.textboxContactUnverifyAction.visible = false;
                this.textboxContactUnknownAction.visible = false;
                this.textboxContactNoResponseAction.visible = false;
                this.switchAddOrderHistComment.visible = false;
            }
        }
        if (!StringUtil.isEmptyString(event.newValue)) {
            this.textboxContactUnverifyAction.required = true;
            this.textboxContactUnknownAction.required = true;
            this.textboxContactNoResponseAction.required = true;
            this.textboxContactUnverifyAction.visible = true;
            this.textboxContactUnknownAction.visible = true;
            this.textboxContactNoResponseAction.visible = true;
            this.switchAddOrderHistComment.visible = StringUtil.equalsIgnoreCase(this.textboxContactUnverifyAction.text, "Proceed")
                || StringUtil.equalsIgnoreCase(this.textboxContactUnknownAction.text, "Proceed")
                || StringUtil.equalsIgnoreCase(this.textboxContactNoResponseAction.text, "Proceed");
        }
    }

    verificationActionOnChange(event: ChangeEvent) {
        if (this.textboxContactUnverifyAction.visible && this.textboxContactUnknownAction.visible && this.textboxContactNoResponseAction.visible) {
            this.switchAddOrderHistComment.visible = StringUtil.equalsIgnoreCase(this.textboxContactUnverifyAction.text, "Proceed")
                || StringUtil.equalsIgnoreCase(this.textboxContactUnknownAction.text, "Proceed")
                || StringUtil.equalsIgnoreCase(this.textboxContactNoResponseAction.text, "Proceed");
        } else {
            this.switchAddOrderHistComment.visible = false;
        }
    }

    switchExcludePnnLanesOnChange(event: ChangeEvent) {
        this.switchShowObservedLanes.visible = !event.newValue;
    }

    tableHighwayEquipmentTypeMappingsBeforeRowSave(event: TableRowBeforeSaveEvent) {
        const modelRow = event.getTableRow().data as ModelRow;
        modelRow.set("code_type", "HWE");
    }

    textboxOrderTypeBeforeLookupModelSearch(event) {
        event.filter.is_active = 'Y';
    }

    textboxDisplayValueBeforeLookupModelSearch(event) {
        event.filter.applies_to = "L";
    }

    switchSendLoadDataOnChange(event: ChangeEvent) {
        this.switchSaveLoadLockAlerts.visible = event.newValue;
        this.textboxFrequency.visible = event.newValue;
        this.textboxLoadDataSync.visible = event.newValue

    }

    switchSaveLoadLockAlertsOnDataDisplay(event: DataDisplayEvent) {
        this.switchSaveLoadLockAlerts.visible = this.switchSendLoadData.checked;
    }
}
